import styled from 'styled-components';
import { theme } from '@evgo/react-material-components';

export const StyledDiv = styled.div<{ marginBottom: number }>`
  display: flex;
  justify-content: space-between;
  margin-bottom: ${(props) => (props.marginBottom ? `${props.marginBottom}px` : `${theme.spacing(4)}px`)};
`;
